import { c as create_ssr_component, e as escape, h as add_styles, d as add_attribute, v as validate_component } from "./ssr.js";
const StdHeading_svelte_svelte_type_style_lang = "";
const css$2 = {
  code: ".std_heading.svelte-1pz9xi6{font-size:4rem;font-style:normal;font-weight:700;line-height:normal;margin:0;padding:0;color:#15181c}.std_heading.small.svelte-1pz9xi6{font-size:3rem}.std_heading.large.svelte-1pz9xi6{font-size:4.4rem}.std_heading.orange.svelte-1pz9xi6{color:#f36d21}.std_heading.blue.svelte-1pz9xi6{color:#0e76bc}.std_heading.white.svelte-1pz9xi6{color:#fff}.std_heading.uppercase.svelte-1pz9xi6{text-transform:uppercase}",
  map: null
};
const StdHeading = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { text_align = "left" } = $$props;
  let { font_family = "REM" } = $$props;
  let { underline = false } = $$props;
  let { size = "small" } = $$props;
  let { max_width = "none" } = $$props;
  let { color = "dark" } = $$props;
  let { uppercase = false } = $$props;
  if ($$props.text_align === void 0 && $$bindings.text_align && text_align !== void 0)
    $$bindings.text_align(text_align);
  if ($$props.font_family === void 0 && $$bindings.font_family && font_family !== void 0)
    $$bindings.font_family(font_family);
  if ($$props.underline === void 0 && $$bindings.underline && underline !== void 0)
    $$bindings.underline(underline);
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.max_width === void 0 && $$bindings.max_width && max_width !== void 0)
    $$bindings.max_width(max_width);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.uppercase === void 0 && $$bindings.uppercase && uppercase !== void 0)
    $$bindings.uppercase(uppercase);
  $$result.css.add(css$2);
  return `<h2 class="${[
    "std_heading " + escape(size, true) + " " + escape(color, true) + " svelte-1pz9xi6",
    uppercase ? "uppercase" : ""
  ].join(" ").trim()}"${add_styles({
    "text-align": text_align,
    "max-width": max_width,
    "font-family": font_family,
    "text-decoration": underline ? "underline" : "none"
  })}>${slots.default ? slots.default({}) : ``} </h2>`;
});
const StdParagraph_svelte_svelte_type_style_lang = "";
const css$1 = {
  code: ".std_paragraph.svelte-1fvsl1l{font-family:Inter;font-style:normal;font-weight:400;line-height:normal;margin:0;padding:0}.std_paragraph.blue.svelte-1fvsl1l{color:#0e76bc}.std_paragraph.orange.svelte-1fvsl1l{color:#f36d21}.std_paragraph.white.svelte-1fvsl1l{color:#fff}.std_paragraph.dark.svelte-1fvsl1l{color:#2d3744}.std_paragraph.black.svelte-1fvsl1l{color:#15181c}.std_paragraph.small.svelte-1fvsl1l{font-size:1.6rem}.std_paragraph.medium.svelte-1fvsl1l{font-size:1.8rem}.std_paragraph.large.svelte-1fvsl1l{font-size:2rem}.std_paragraph.xl.svelte-1fvsl1l{font-size:2.4rem}",
  map: null
};
const StdParagraph = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { color = "white" } = $$props;
  let { text_align = "left" } = $$props;
  let { max_width = "none" } = $$props;
  let { size = "medium" } = $$props;
  let { text_decoration = "none" } = $$props;
  let { font_style = "none" } = $$props;
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.text_align === void 0 && $$bindings.text_align && text_align !== void 0)
    $$bindings.text_align(text_align);
  if ($$props.max_width === void 0 && $$bindings.max_width && max_width !== void 0)
    $$bindings.max_width(max_width);
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.text_decoration === void 0 && $$bindings.text_decoration && text_decoration !== void 0)
    $$bindings.text_decoration(text_decoration);
  if ($$props.font_style === void 0 && $$bindings.font_style && font_style !== void 0)
    $$bindings.font_style(font_style);
  $$result.css.add(css$1);
  return `<p class="${"std_paragraph " + escape(size, true) + " " + escape(color, true) + " svelte-1fvsl1l"}"${add_styles({
    "text-align": text_align,
    "max-width": max_width,
    "text-decoration": text_decoration,
    "font-style": font_style
  })}>${slots.default ? slots.default({}) : ``} </p>`;
});
const ChevronRight = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const Button_svelte_svelte_type_style_lang = "";
const css = {
  code: ".wrapper.svelte-1qajp9f{display:flex;gap:2rem;align-items:center;padding:0.8rem 0.8rem 0.8rem 2rem;font-size:1.4rem;font-weight:700;border-radius:1rem;color:#fff;text-transform:uppercase;text-decoration:none}.wrapper.blue.svelte-1qajp9f{background-color:#0e76bc}.wrapper.blue.svelte-1qajp9f:hover{background-color:#2a86c4}.wrapper.orange.svelte-1qajp9f{background-color:#f36d21}.wrapper.orange.svelte-1qajp9f:hover{background-color:#f47e3b}.wrapper.transparent.svelte-1qajp9f{background-color:transparent}.wrapper.white.svelte-1qajp9f{background-color:#fff;color:#0e76bc}.wrapper.white.svelte-1qajp9f:hover{background-color:#e5e5e5}.wrapper.large.svelte-1qajp9f{font-size:1.8rem;padding:1.4rem 0.8rem 1.4rem 2rem}.centered.svelte-1qajp9f{justify-content:center}",
  map: null
};
const Button = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { href = void 0 } = $$props;
  let { target = void 0 } = $$props;
  let { color = "blue" } = $$props;
  let { size = "small" } = $$props;
  let { centered = false } = $$props;
  if ($$props.href === void 0 && $$bindings.href && href !== void 0)
    $$bindings.href(href);
  if ($$props.target === void 0 && $$bindings.target && target !== void 0)
    $$bindings.target(target);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.centered === void 0 && $$bindings.centered && centered !== void 0)
    $$bindings.centered(centered);
  $$result.css.add(css);
  return `<a class="${[
    "wrapper " + escape(color, true) + " " + escape(size, true) + " svelte-1qajp9f",
    centered ? "centered" : ""
  ].join(" ").trim()}"${add_attribute("href", href, 0)}${add_attribute("target", target, 0)}>${slots.default ? slots.default({}) : ``} ${validate_component(ChevronRight, "ChevronRight").$$render($$result, { size: "2.4rem", color: "white" }, {}, {})} </a>`;
});
export {
  Button as B,
  StdHeading as S,
  StdParagraph as a
};
